import { stripDomain } from '@hotjar/webapp/utils/urls';
import * as Segment from '@hotjar/webapp/domains/common/tracking/segment';
import type { TrackingArgs } from './types';
import { validateEventData } from './validate-event-data';
import * as hotjarTracking from './tools/hotjar';

/**
 * Track when something was clicked.
 *
 * TODO: Future person: this function has been re-exported by subscription-management, if you extract this out of webapp into a standalone util please inform `@hotjar/monetization-platform` or `@hotjar/billing` FE so they are aware 🙏
 */
export const trackClick = ({
  name,
  uiPosition,
  groupData,
  data = {},
}: TrackingArgs): Promise<void> => {
  const valid = validateEventData('Track.click', [name, uiPosition, groupData]);

  if (valid) {
    const url = stripDomain(window.location.href);
    const trackData = {
      element_name: name,
      ui_position: uiPosition,
      url_event_was_triggered_on: url, // we add the url_event_was_triggered_on as current page url in case it is not defined in the groupData
      ...data,
      ...groupData,
    };

    hotjarTracking.tagRecording(`Clicked: ${name} - ${uiPosition}`);
    return Segment.track('Element Clicked', trackData);
  }

  return Promise.resolve();
};
